/**
 * @file 城市筛选页面
 * @date 2019/09/23
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavBar, SearchBar, WhiteSpace, List, Toast, Icon} from 'antd-mobile';
import {SearchMask, IndexNav, Indicator, PositionCity, SearchArea} from '../../component';
import NavBarComponent from '../../component/common/NavBarComponent';
import {SAVE_CITY_GAI_INFO, SAVE_CITY_GET_INFO,} from '../../redux/actions/homeAction';
import {
    LASTEST_CITY,
    getAllCities,
    saveLocalStorageCity,
    getLocalStorageCity,
    searchCityByName,
    transformCityMenuData
} from '../../services/cityServices';
import {throttle, parseSearchToState, parseStateToSearch} from '../../util/util';
import './city.css';

const Item = List.Item;
const searchCity = throttle(searchCityByName);

class City extends Component {
    constructor(props) {
        super(props);
        this.state = {
            localCity: '北京',
            hotCity: [],
            latestCity: [],
            city: {},
            labels: [],
            searchCities: [],

            moving: false,
            indicator: '',
            loading: false,
            searchArea: false
        };
    }

    componentDidMount = () => {
        this.setState(() => {
            Toast.loading('Loading...');
            return {loading: true};
        });
        Promise.all([getAllCities(), getLocalStorageCity(LASTEST_CITY)]).then(result => {
            const localCity = '北京';
            const res = result[0].afterFilterAllCity;
            const city = res.allCity;
            const labels = res.validateLetters;
            const hotCity = res.hotCity;
            const latestCity = result[1];
            this.setState(() => {
                Toast.hide();
                return {
                    localCity,
                    city,
                    hotCity,
                    labels,
                    latestCity,
                    loading: false
                };
            });
        });
    }

    onSearchInput = async value => {
        if (!value) {
            this.hideMenuDialog();
            return;
        }

        const {labels, city} = this.state;
        const cities = await searchCity(value, labels, city);
        this.setState({
            searchArea: true,
            searchCities: transformCityMenuData(cities)
        });
        if (cities.length === 0) {
            Toast.info('抱歉，暂无搜索结果～');
        }
    }

    hideMenuDialog = () => {
        this.setState({
            searchArea: false,
            searchCities: []
        });
    }

    renderLocalCity = () => {
        const locationCityInfo = localStorage.getItem('locationCityInfo');
        const {cityName, coordinatePoint, cityId} = JSON.parse(locationCityInfo);
        return <div className="city-local">
                    <p>你所在地区</p>
                    <ul>
                        <li className="city-item" onClick={() => this.onSelectCity({cityName, coordinatePoint, cityId})}>
                            <span className="city-location" />
                            <span className="city-local-text">{cityName}</span>
                        </li>
                    </ul>
                </div>;
    }

    renderHotCity = () => {
        const {hotCity} = this.state;
        return <div className="city-local">
            <p>热门城市</p>
            <ul>
            {
                hotCity.map(item => {
                    let {cityName, coordinatePoint, cityId} = item;
                    return <li className="city-item" key={item.cityId} onClick={() => this.onSelectCity({cityName, coordinatePoint, cityId})}>
                            <span className="city-local-text">{cityName}</span>
                        </li>;
                })
            }
            </ul>
        </div>;
    }

    renderCities = () => {
        const {city} = this.state;
        return Object.keys(city).map(letter => {
            const cList = city[letter];
            return (
                <div key={ letter } ref={ element => this[`section${letter}`] = element }>
                    <List renderHeader={ () => letter } className="select-city-list">
                        {
                            cList.length > 0 && cList.map(c => {
                                return <Item key={ c.cityName } onClick={ () => this.onSelectCity(c) }>{ c.cityName }</Item>;
                            })
                        }
                    </List>
                </div>
            );
        });
    }

    renderSearchCity = () => {
        const {searchCities} = this.state;
        return <SearchArea city={ searchCities } onChange={ this.onChangeMenu }/>;
    }

    onChangeMenu = value => {
        this.hideMenuDialog();
        this.onSelectCity(JSON.parse(value));
    }

    onSelectCity = city => {
        if (this.state.moving) {
            return;
        }
        const {history, location} = this.props;
        const search = location.search;
        const {cityCode, ...rest} = parseSearchToState(search);
        const backCity = typeof city === 'string' ? city : city.city;
        rest[`city${cityCode}`] = backCity;
        saveLocalStorageCity(LASTEST_CITY, backCity);
        history.push({
            pathname: '/stores',
            search: parseStateToSearch({cityclasses: cityCode, ...rest, ...city})
        });
    }

    onNavChange = nav => {
        this.setState(() => {
            const label = nav.label ? nav.label : this.state.label;
            const moving = nav.moving ? nav.moving : this.state.moving;
            this[`section${label}`] && this[`section${label}`].scrollIntoView();
            return {
                moving
            };
        });
    }

    render() {
        const {labels, indicator, moving, loading, searchArea} = this.state;
        if (loading) {
            return null;
        }
        return (
            <div className="city page">
                <div className="city-top">
                    <NavBarComponent>
                        <NavBar
                            mode="light"
                            icon={ <Icon type="left" color='#333'/> }
                            leftContent=""
                            onLeftClick={ () => this.props.history.goBack() }
                            >
                                选择城市
                        </NavBar>
                    </NavBarComponent>
                    <SearchBar
                        placeholder="请输入你要选择的城市"
                        maxLength={8}
                        onChange={ this.onSearchInput } />
                </div>
                <div className="city-list">
                    <div className="city-search-area">
                        { searchArea && this.renderSearchCity() }
                    </div>
                    <SearchMask show={ searchArea } city={ this.state.searchCities } />
                    <div className="city-list-content">
                        { this.renderLocalCity() }
                        <WhiteSpace size="md" />
                        { this.renderHotCity() }
                        { this.renderCities() }
                        <Indicator indicator={ indicator } />
                    </div>
                    <div className="city-label">
                        <IndexNav labels={ labels } moving={ moving } onNavChange={ this.onNavChange } />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        cityInfo: state.homeReducer.cityInfo
    };
};

City = connect(mapStateToProps)(City);


export default City;
